import type { PlateSegment } from '../types'
import { isObject } from './utils'

const isPlateSegment = (value: unknown): value is PlateSegment =>
  isObject(value) &&
  typeof value.text === 'string' &&
  Number.isInteger(value.blockIndex)

export const isPlate = (value: unknown): value is PlateSegment[] =>
  Array.isArray(value) && value.every(isPlateSegment)
